import ComparisonWithOtherAsset from "./components/ComparisonWithOtherAsset";

function ComparisonWithOtherTable() {
  return (
    <div>
      <div class="row heading">
        <div class="col-3 col-md-4"></div>
        <div
          class="table-heading table-heading-blue col-6 col-md-4 fw-bold fs-5 text-center p-4"
        >
          Logicmojo
        </div>
        <div
        class="table-heading table-heading-gray col-3 fw-bold fs-5 text-center p-4"
        >
          Others
        </div>
      </div>

      <div
        class="row data-row-1 row-white align-items-center"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">
            Live Online Classes
          </div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="tick" />
            Live online classes led by instructors
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="cross" />
          </div>
        </div>
      </div>

      <div
        class="row align-items-center row-slate"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Course Fee</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
          <ComparisonWithOtherAsset type="tick" />
            Very high value for money
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">Expensive</div>
        </div>
      </div>

      <div
        class="row align-items-center row-white"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Curriculum</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            
            Updated every month as per industry requirements
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">Not up-to-date</div>
        </div>
      </div>

      <div
        class="row align-items-center row-slate"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Projects</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
          <ComparisonWithOtherAsset type="tick" />
            Industry-aligned projects with project presentation guidance
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">Not industry-aligned</div>
        </div>
      </div>

      <div
        class="row align-items-center row-white"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Mock Interviews</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="tick" />
            With a dedicated team of experts
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="cross" />
          </div>
        </div>
      </div>

      <div
        class="row align-items-center row-slate"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Career Services</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="tick" />
            Extensive services, including resume-building and behavioral skills
            workshops
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="wrong" />
          </div>
        </div>
      </div>

      <div
        class="row align-items-center row-white"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">Support</div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="tick" />
            A dedicated support team
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="wrong" />
          </div>
        </div>
      </div>

      <div
        class="row align-items-center row-slate table-bottom"
      >
        <div class="col-3 col-md-4 px-lg-2 pe-0 ps-0">
          <div class="fw-bold fs-6 text-start p-lg-3 p-1">
            Salary Negotiation
          </div>
        </div>
        <div
          class="col-6 col-md-4 px-lg-2 px-0 border-col-primary align-self-stretch border-bottom rounded-bottom-5"
        >
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="tick" />
            For higher salaries
          </div>
        </div>
        <div class="col-3 px-lg-2 px-0">
          <div class="fs-6 text-center p-lg-3 p-1">
            <ComparisonWithOtherAsset type="wrong" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ComparisonWithOtherTable;
